import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';

export const GET_CHATS_LIST = '@chat/get-chats-list';
export const GET_CHATS_LIST_SUCCESS = '@chat/get-chats-list-success';
export const GET_CHATS_LIST_ERROR = '@chat/get-chats-list-error';

export const GET_CONTACTS = '@chat/get-contacts';
export const GET_CONTACTS_SUCCESS = '@chat/get-contacts-success';
export const GET_CONTACTS_ERROR = '@chat/get-contacts-error';
export const SET_CONTACTS_QUERY = '@chat/set-contacts-query';

export const GET_MORE_CHAT_MESSAGES = '@chat/get-more-chat-messages';
export const GET_MORE_CHAT_MESSAGES_SUCCESS = '@chat/get-more-chat-messages-success';
export const GET_MORE_CHAT_MESSAGES_ERROR = '@chat/get-more-chat-messages-error';

export const GET_MORE_SCHEDULED_CHAT_MESSAGES = '@chat/get-more-scheduled-chat-messages';
export const GET_MORE_SCHEDULED_CHAT_MESSAGES_SUCCESS = '@chat/get-more-scheduled-chat-messages-success';
export const GET_MORE_SCHEDULED_CHAT_MESSAGES_ERROR = '@chat/get-more-scheduled-chat-messages-error';

export const GET_FILTERED_CHAT_MESSAGES = '@chat/get-filtered-chat-messages';
export const GET_FILTERED_CHAT_MESSAGES_SUCCESS = '@chat/get-filtered-chat-messages-success';
export const GET_FILTERED_CHAT_MESSAGES_ERROR = '@chat/get-filtered-chat-messages-error';

export const CLEAR_FILTERED_CHAT_MESSAGES = '@chat/clear-filtered-chat-messages';

export const MARK_CHAT_AS_SEEN = '@chat/mark-chat-as-seen';
export const MARK_CHAT_AS_SEEN_SUCCESS = '@chat/mark-chat-as-seen-success';
export const MARK_CHAT_AS_SEEN_ERROR = '@chat/mark-chat-as-seen-error';

export const MARK_CHAT_AS_UNREAD = '@chat/mark-chat-as-unread';
export const MARK_CHAT_AS_UNREAD_SUCCESS = '@chat/mark-chat-as-unread-success';
export const MARK_CHAT_AS_UNREAD_ERROR = '@chat/mark-chat-as-unread-error';

export const ADD_MESSAGE = '@chat/add-message';
export const ADD_MESSAGE_SUCCESS = '@chat/add-message-success';
export const ADD_MESSAGE_ERROR = '@chat/add-message-error';

export const SOCKET_CHAT_TOTAL_UNREAD_COUNT = '@chat/socket-chat-total-unread-count';

export const SOCKET_CHAT_NEW_MESSAGE = '@chat/socket-chat-new-message';

export const SOCKET_CHAT_NEW_SCHEDULED_MESSAGE = '@chat/socket-chat-new-scheduled-message';

export const SOCKET_CHAT_MESSAGE_DELETE = '@chat/socket-chat-message-delete';

export const SOCKET_CHAT_SCHEDULED_MESSAGE_DELETE = '@chat/socket-chat-scheduled-message-delete';

export const SOCKET_CHAT_SCHEDULED_MESSAGE_UPDATE = '@chat/socket-chat-scheduled-message-update';

export const SOCKET_CHAT_MESSAGE_SENT = '@chat/socket-chat-message-sent';

export const SOCKET_CHAT_SCHEDULED_MESSAGE_SENT = '@chat/socket-chat-scheduled-message-sent';

export const SOCKET_CHAT_MESSAGE_READ = '@chat/socket-chat-message-read';

export const SOCKET_CHAT_MESSAGE_DELIVERED = '@chat/socket-chat-message-delivered';

export const SOCKET_CHAT_AI_DRAFT_READY = '@chat/socket-chat-ai-draft-ready';

export const SOCKET_CHAT_DELETED = '@chat/socket-chat-deleted';
export const CLEAR_DELETED_CHAT_KEY = '@chat/clear-deleted-chat-key';

export const SEND_NOW_OR_EDIT_SCHEDULED_MESSAGE = '@chat/send-now-or-edit-scheduled-message';
export const SEND_NOW_OR_EDIT_SCHEDULED_MESSAGE_SUCCESS = '@chat/send-now-or-edit-scheduled-message-success';
export const SEND_NOW_OR_EDIT_SCHEDULED_MESSAGE_ERROR = '@chat/send-now-or-edit-scheduled-message-error';

export const SET_CURRENT_MESSAGE = '@chat/set-current-message';
export const SET_FILE_UPLOAD_TO_MESSAGE = '@chat/set-file-upload-to-message';

export const DELETE_CHAT_MESSAGE = '@chat/delete-chat-message';
export const DELETE_CHAT_MESSAGE_SUCCESS = '@chat/delete-chat-message-success';
export const DELETE_CHAT_MESSAGE_ERROR = '@chat/delete-chat-message-error';

export const GET_FOLLOW_UP_MESSAGES = '@chat/get-follow-up-messages';
export const GET_FOLLOW_UP_MESSAGES_SUCCESS = '@chat/get-follow-up-messages-success';
export const GET_FOLLOW_UP_MESSAGES_ERROR = '@chat/get-follow-up-messages-error';

export const REPLACE_SYSTEM_GEN_MESSAGE = '@chat/replace-system-gen-message';
export const REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS = '@chat/replace-system-gen-message-success';
export const REPLACE_SYSTEM_GEN_MESSAGE_ERROR = '@chat/replace-system-gen-message-error';

export const GET_MORE_CHATS = '@chat/get-more-chats';
export const GET_MORE_CHATS_SUCCESS = '@chat/get-more-chats-success';
export const GET_MORE_CHATS_ERROR = '@chat/get-more-chats-error';
export const RESET_CHATS_LIST = '@chat/reset-chats-list';

export const UPDATE_CHAT_PREFERENCES = '@chat/update-chat-preferences';
export const UPDATE_CHAT_PREFERENCES_SUCCESS = '@chat/update-chat-preferences-success';
export const UPDATE_CHAT_PREFERENCES_ERROR = '@chat/update-chat-preferences-error';

export const SAVE_DRAFT = '@chat/save-draft';
export const SAVE_DRAFT_SUCCESS = '@chat/save-draft-success';
export const SAVE_DRAFT_ERROR = '@chat/save-draft-error';

export const DELETE_DRAFT = '@chat/delete-draft';
export const DELETE_DRAFT_SUCCESS = '@chat/delete-draft-success';
export const DELETE_DRAFT_ERROR = '@chat/delete-draft-error';

// CON-1746 search hardening. Every page-1 (reset) list request advances a
// generation and every response carries the generation it was started under;
// the reducer drops any response older than the current one. Without this a
// slow earlier search ("Tom", 30 s cold) landed after a faster later one
// ("Tomes", 2 s) and replaced its results. Load-more requests carry the
// generation too, so a stale page cannot append to a newer list either.
let chatsListGeneration = 0;

export const getChatsListGeneration = () => chatsListGeneration;

export const getChatsList = (reset = true, searchText = '', filterOptions = {}) => async (dispatch) => {
  if (reset) {
    chatsListGeneration += 1;
  }
  const generation = chatsListGeneration;

  dispatch({
    type: reset ? GET_CHATS_LIST : GET_MORE_CHATS,
    meta: { generation },
  });
  try {
    const {
      type,
      flagColor,
      showArchived,
      showDrafts,
    } = filterOptions || {};

    const params = {
      page: 1,
      limit: 50,
      filters: {
        type,
        flagColor,
        showArchived,
        showDrafts,
      },
    };

    // Add search param if provided
    if (searchText && searchText.trim()) {
      params.search = searchText.trim();
    }

    const response = await axios.get('/api/messages/chats', { params });

    dispatch({
      type: reset ? GET_CHATS_LIST_SUCCESS : GET_MORE_CHATS_SUCCESS,
      payload: response?.data || {},
      meta: { generation },
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_CHATS_LIST_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: reset ? GET_CHATS_LIST_ERROR : GET_MORE_CHATS_ERROR,
      meta: { generation },
    });
  }
};

export const getMoreChats = (page, searchText = '', filterOptions = {}) => async (dispatch) => {
  const generation = chatsListGeneration;

  dispatch({
    type: GET_MORE_CHATS,
    meta: { generation },
  });
  try {
    const {
      type,
      flagColor,
      showArchived,
      showDrafts,
    } = filterOptions || {};

    const params = {
      page,
      limit: 50,
      filters: {
        type,
        flagColor,
        showArchived,
        showDrafts,
      },
    };

    // Add search param if provided
    if (searchText && searchText.trim()) {
      params.search = searchText.trim();
    }

    const response = await axios.get('/api/messages/chats', { params });

    dispatch({
      type: GET_MORE_CHATS_SUCCESS,
      payload: response?.data || {},
      meta: { generation },
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_MORE_CHATS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_MORE_CHATS_ERROR,
      meta: { generation },
    });
  }
};

export const getContacts = (isSearch = false, query = null) => async (dispatch, getState) => {
  dispatch({
    type: GET_CONTACTS,
  });
  try {
    const response = await axios.post('/api/contacts', query || getState()?.chat?.allContactsList?.query || {});
    dispatch({
      type: GET_CONTACTS_SUCCESS,
      payload: {
        isSearch,
        data: response?.data || {},
      }
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_CONTACTS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_CONTACTS_ERROR,
    });
  }
};

export const setContactsQuery = (query) => ({
  type: SET_CONTACTS_QUERY,
  payload: query
});

export const getMoreChatMessages = (cursor, contactId, phone) => async (dispatch, getState) => {
  dispatch({
    type: GET_MORE_CHAT_MESSAGES,
  });
  try {
    const response = await axios.get('/api/messages', {
      params: {
        cursor: cursor || undefined,
        contactId: contactId || undefined,
        phone: phone || undefined,
      },
    });

    const { customer } = getState()?.customerDetails || {};

    dispatch({
      type: GET_MORE_CHAT_MESSAGES_SUCCESS,
      payload: {
        contactId,
        contact: customer?.id && customer.id === helpers.transform.toInt10(contactId) ? customer : null,
        data: response?.data || {},
      }
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_MORE_CHAT_MESSAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_MORE_CHAT_MESSAGES_ERROR,
    });
  }
};

export const getMoreScheduledChatMessages = (cursor, contactId, phone) => async (dispatch) => {
  dispatch({
    type: GET_MORE_SCHEDULED_CHAT_MESSAGES,
  });
  try {
    const response = await axios.get('/api/messages/scheduled', {
      params: {
        cursor: cursor || undefined,
        contactId: contactId || undefined,
        phone: phone || undefined,
      },
    });
    dispatch({
      type: GET_MORE_SCHEDULED_CHAT_MESSAGES_SUCCESS,
      payload: {
        contactId,
        data: response?.data || {},
      }
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_MORE_SCHEDULED_CHAT_MESSAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_MORE_SCHEDULED_CHAT_MESSAGES_ERROR,
    });
  }
};

export const getFilteredChatMessages = ({ cursor, contactId, phone }) => async (dispatch) => {
  dispatch({
    type: GET_FILTERED_CHAT_MESSAGES,
  });
  try {
    const params = {
      cursor: cursor || undefined,
      contactId: contactId || undefined,
      phone: phone || undefined,
    };

    const [messagesResponse, scheduledResponse] = await Promise.all([
      axios.get('/api/messages', { params }),
      axios.get('/api/messages/scheduled', { params })
    ]);

    dispatch({
      type: GET_FILTERED_CHAT_MESSAGES_SUCCESS,
      payload: {
        chatKey: contactId,
        filteredByPhone: phone || '',
        regularMessages: messagesResponse?.data || [],
        scheduledMessages: scheduledResponse?.data || [],
      }
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_FILTERED_CHAT_MESSAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_FILTERED_CHAT_MESSAGES_ERROR,
    });
  }
};

export const clearFilteredChatMessages = () => ({
  type: CLEAR_FILTERED_CHAT_MESSAGES,
});

export const markChatAsSeen = (chatKey, unreadMessageIds) => async (dispatch) => {
  dispatch({
    type: MARK_CHAT_AS_SEEN,
  });
  try {
    const response = await axios.patch('/api/messages/read', {
      id: unreadMessageIds,
    });
    dispatch({
      type: MARK_CHAT_AS_SEEN_SUCCESS,
      payload: {
        chatKey,
        updatedMessages: response?.data || [],
      }
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(MARK_CHAT_AS_SEEN_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: MARK_CHAT_AS_SEEN_ERROR,
    });
  }
};

export const markChatAsUnread = (chatKey, doWhenTry = false, doWhenCatch = false,) => async (dispatch) => {
  dispatch({
    type: MARK_CHAT_AS_UNREAD,
  });
  try {
    const response = await axios.patch('/api/messages/unread', {
      contactId: chatKey
    });
    dispatch({
      type: MARK_CHAT_AS_UNREAD_SUCCESS,
      payload: {
        chatKey,
        updatedMessages: response?.data || [],
      }
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(MARK_CHAT_AS_UNREAD_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: MARK_CHAT_AS_UNREAD_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const addMessage = (isScheduledMessage = false, sendData, chatKey, doWhenTry = false, doWhenCatch = false) => async (dispatch, getState) => {
  dispatch({
    type: ADD_MESSAGE,
  });
  try {
    const url = isScheduledMessage ? '/api/messages/scheduled' : '/api/messages';
    const response = await axios.post(url, sendData);

    dispatch({
      type: ADD_MESSAGE_SUCCESS,
      payload: {
        chatKey,
        messages: isScheduledMessage ? [] : response?.data || [],
        scheduledMessages: isScheduledMessage ? response?.data || [] : [],
        contact: getState().customerDetails.customer,
      }
    });

    if (doWhenTry) {
      doWhenTry(isScheduledMessage);
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(ADD_MESSAGE_ERROR, helpers.transform.toString(message || error?.message || error?.error || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: ADD_MESSAGE_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const socketChatTotalUnreadCount = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_TOTAL_UNREAD_COUNT,
    payload: message,
  });
};

export const socketChatNewMessage = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_NEW_MESSAGE,
    payload: {
      ...message,
      isSocketEventChatNewMessage: true,
    },
  });
};

export const socketChatNewScheduledMessage = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_NEW_SCHEDULED_MESSAGE,
    payload: message,
  });
};

export const socketChatMessageDelete = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_MESSAGE_DELETE,
    payload: message,
  });
};

export const socketChatScheduledMessageDelete = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_SCHEDULED_MESSAGE_DELETE,
    payload: message,
  });
};

export const socketChatScheduledMessageUpdate = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_SCHEDULED_MESSAGE_UPDATE,
    payload: message,
  });
};

export const socketChatMessageSent = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_MESSAGE_SENT,
    payload: message,
  });
};

export const socketChatMessageRead = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_MESSAGE_READ,
    payload: message,
  });
};

export const socketChatMessageDelivered = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_MESSAGE_DELIVERED,
    payload: message,
  });
};

export const socketChatScheduledMessageSent = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_SCHEDULED_MESSAGE_SENT,
    payload: message,
  });
};

// CON-1673. An AI draft or research note landed for a contact. Drafts arrive a
// median 3m40s after the inbound message, inside the band where the support
// person is most likely to already have the thread open, so without this the
// page shows her nothing until a reload or a chat switch.
//
// The payload carries { contactId, kind, chatPreferences } and no note text.
// For a draft the preferences are merged straight in; for an escalation there
// is nothing to merge and the version bump alone tells the note panel to
// refetch.
export const socketAiDraftReady = (payload) => async (dispatch) => {
  const { contactId, kind, chatPreferences } = payload || {};
  if (!contactId) return;

  dispatch({
    type: SOCKET_CHAT_AI_DRAFT_READY,
    payload: {
      contactId: String(contactId),
      kind: kind || 'draft',
      chatPreferences: chatPreferences || null,
    },
  });
};

export const socketChatDeleted = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_CHAT_DELETED,
    payload: message,
  });
};

export const clearDeletedChatKey = () => async (dispatch) => {
  dispatch({
    type: CLEAR_DELETED_CHAT_KEY,
  });
};

export const sendOrEditScheduledMessage = (sendData, chatKey, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: SEND_NOW_OR_EDIT_SCHEDULED_MESSAGE,
  });
  try {
    const isSendNow = sendData?.sendNow;
    const response = await axios.patch('/api/messages/scheduled', sendData);

    dispatch({
      type: SEND_NOW_OR_EDIT_SCHEDULED_MESSAGE_SUCCESS,
      payload: {
        chatKey,
        isSendNow,
        updatedMessage: response?.data || {},
      }
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(SEND_NOW_OR_EDIT_SCHEDULED_MESSAGE_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_NOW_OR_EDIT_SCHEDULED_MESSAGE_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setCurrentMessage = (message) => ({
  type: SET_CURRENT_MESSAGE,
  payload: message,
});

export const setFileUploadToMessage = (file, isMessageEdit = false) => ({
  type: SET_FILE_UPLOAD_TO_MESSAGE,
  payload: {
    file,
    isMessageEdit,
  }
});

export const deleteChatMessage = (chatKey, messageId, isScheduledMessage = false) => async (dispatch) => {
  dispatch({
    type: DELETE_CHAT_MESSAGE,
  });
  try {
    const response = await axios.delete('/api/messages', {
      data: { id: [messageId] },
    });
    dispatch({
      type: DELETE_CHAT_MESSAGE_SUCCESS,
      payload: {
        chatKey,
        messageId,
        isScheduledMessage,
        updatedMessages: response?.data || [],
      }
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(DELETE_CHAT_MESSAGE_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: DELETE_CHAT_MESSAGE_ERROR,
    });
  }
};

export const getFollowUpMessages = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES,
    });
    const { data } = await axios.post('/api/followupmessages/template-tag') || {};
    const { error } = data || {};

    if (error) {
      dispatch({
        type: GET_FOLLOW_UP_MESSAGES_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
      payload: data?.messages,
    });
  } catch (e) {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_ERROR,
    });
  }
};

export const clearFollowUpMessages = () => ({
  type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
});

export const replaceSystemGenMessage = (systemGenMessage, dynamicFieldsObj, isMessageEdit = false) => async (dispatch) => {
  try {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE,
    });
    const { data } = await axios.post('/api/contacts/replace-system-gen-message', {
      systemGenMessage,
      ...dynamicFieldsObj,
    }) || {};

    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
      payload: {
        isMessageEdit,
        messageWithReplacedFields: data?.message || '',
      }
    });
  } catch (e) {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
    });
  }
};

export const clearSystemGenMessageReplacedFlag = (isMessageEdit = false) => ({
  type: REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
  payload: { isMessageEdit },
});

export const resetChatsList = () => ({
  type: RESET_CHATS_LIST,
});

export const updateChatPreferences = (contactId, preferences, onSuccess = null, onError = null) => async (dispatch) => {
  dispatch({
    type: UPDATE_CHAT_PREFERENCES,
  });
  try {
    const response = await axios.patch(`/api/messages/chats/${contactId}/preferences`, preferences);
    // Backend returns { contactId, isPinned, pinnedAt, flagColor, isArchived, ... }
    // Extract chatPreferences fields from the response
    const {
      isPinned,
      pinnedAt,
      flagColor,
      isArchived,
      draftMessage,
      draftAttachments,
    } = response?.data || {};

    dispatch({
      type: UPDATE_CHAT_PREFERENCES_SUCCESS,
      payload: {
        // Use string contactId to match state keys
        contactId: String(contactId),
        chatPreferences: {
          isPinned,
          pinnedAt,
          flagColor,
          isArchived,
          draftMessage,
          draftAttachments,
        },
      }
    });

    if (onSuccess) {
      onSuccess(response?.data);
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_CHAT_PREFERENCES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_CHAT_PREFERENCES_ERROR,
    });

    if (onError) {
      onError(e);
    }
  }
};

export const saveDraft = (contactId, draftData, onSuccess = null, onError = null) => async (dispatch) => {
  dispatch({
    type: SAVE_DRAFT,
  });
  try {
    const response = await axios.put(`/api/messages/chats/${contactId}/draft`, draftData);
    // Backend returns { contactId, draftMessage, draftAttachments, draftTemplate, draftSource }
    // draftSource/draftTemplate must be merged too: a user save always clears
    // them server side, and without them the store keeps a stale 'ai' source,
    // which made the AI draft and template chips reappear a second after she
    // started editing (the reducer merges only the keys sent here).
    const {
      draftMessage, draftAttachments, draftSource = null, draftTemplate = null,
    } = response?.data || {};

    dispatch({
      type: SAVE_DRAFT_SUCCESS,
      payload: {
        contactId: String(contactId),
        chatPreferences: {
          draftMessage,
          draftAttachments,
          draftTemplate,
          draftSource,
        },
      }
    });

    if (onSuccess) {
      onSuccess(response?.data);
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(SAVE_DRAFT_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SAVE_DRAFT_ERROR,
    });

    if (onError) {
      onError(e);
    }
  }
};

export const deleteDraft = (contactId, onSuccess = null, onError = null) => async (dispatch) => {
  dispatch({
    type: DELETE_DRAFT,
  });
  try {
    const response = await axios.delete(`/api/messages/chats/${contactId}/draft`);
    // Backend clears every draft column, so mirror all of them into the store
    dispatch({
      type: DELETE_DRAFT_SUCCESS,
      payload: {
        contactId: String(contactId),
        chatPreferences: {
          draftMessage: null,
          draftAttachments: null,
          draftTemplate: null,
          draftSource: null,
        },
      }
    });

    if (onSuccess) {
      onSuccess(response?.data);
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(DELETE_DRAFT_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: DELETE_DRAFT_ERROR,
    });

    if (onError) {
      onError(e);
    }
  }
};
